var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsertPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "url(#pattern0_2020_44)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2020_44",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2020_44",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2020_44",
    width: 96,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAACMUlEQVR4nO2dPU5cYRAEO4Gz2OaApA4tYRsQpzE+BvggNs7WUqOVXoAIwPzMTs03U1Ln3VP7djd70jAMwzAMwzAMw9s5kXQu6VbSX0lOzucuUo8lXUn6Bzi6u0nYH/8n4NDuKuEKcGB3lXAC/dpxFwkXgKP6hfmihfgF/IS705NwBzi6H2TPaacnwUABrSRQBbSRQBbQQgJdwPISKghYWkIVActKqCRgSQnVBCwnoaKApSRUFbCMhMoClpBQXUB5CSsIKC1hFQFlJawkoKSE1QSUk7CigJdISCf74A48yP9ISCf74A4+yHMS0sk+uA9wkKckpOPmScfNk46bJx03TzpunnTcPOm4edJx86RDG2xYn3Bogw3rEw5tsGF9wqENNqxPOLTBhvUJhzbYsD7h0AYb1icc2mDD+oRDG2xYn3Bogw3rEw5tsGF9wqENNqxPONUHuHj/8gNcvH/5AS7ev/wAF+9ffoCL9y8/wMX7lx/g4v3LD3Dx/m8e4HceTOsTDm2wYX3CoQ02rE84tMGG9QmHNtiwPuHQBhvWJxzaYMP6hEMbbFifcGiDDesTDm2wYX3CoQ02rE84tMGG9QnHzZOOmycdN086bp50/gCO4KT8FoBbwCGclBsB+A44hJNyJgCfir3Gyu+UnaQPgnAJOIgPnP2Tj+FI0jXgKD5QfmybURxtL3XbAQ7koOy2Tz7u+I9/E75t/xBo7xjzK3K3bfkq6WP2cYdhGIZhGIZhUHnuAZdA9GtIchA+AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsertPage);
export default __webpack_public_path__ + "static/media/Insert Page.0aeaeaaa5ca8a1be0820c65a7e21cdb1.svg";
export { ForwardRef as ReactComponent };